"use strict";

function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return right[Symbol.hasInstance](left); } else { return left instanceof right; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!_instanceof(instance, Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductGroupPage = exports.default = void 0;

var _exports = _interopRequireDefault(require("exports"));

var _react = _interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _base = _interopRequireWildcard(require("block/base"));

var _classList = _interopRequireDefault(require("class-list"));

var _CatalogGroupPage = require("CatalogGroupPage");

var _CatalogGroup = require("pages/CatalogGroup");

var _cart = _interopRequireDefault(require("cart"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _temp, _dec, _dec2, _class3, _descriptor9, _descriptor10, _descriptor11, _temp2;

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _initializerDefineProperty(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.');
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ProductGroup = (_dec = (0, _decorators.alias)("content.type"), _dec2 = (0, _decorators.alias)("content.name"), (_class3 = (_temp2 =
/*#__PURE__*/
function (_react$Component) {
  _inherits(ProductGroup, _react$Component);

  function ProductGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ProductGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ProductGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _initializerDefineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "content", _descriptor9, _assertThisInitialized(_assertThisInitialized(_this)));

    _initializerDefineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "type", _descriptor10, _assertThisInitialized(_assertThisInitialized(_this)));

    _initializerDefineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "name", _descriptor11, _assertThisInitialized(_assertThisInitialized(_this)));

    return _this;
  }

  _createClass(ProductGroup, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(ProductGroupPage, this.content);
    }
  }], [{
    key: "value",
    value: function value(landingPageGroup, group, page) {
      return ProductGroupPage.value(landingPageGroup, group, page);
    }
  }]);

  return ProductGroup;
}(_react.Component), _temp2), (_descriptor9 = _applyDecoratedDescriptor(_class3.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class3.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class3.prototype, "name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3));
exports.default = ProductGroup;
var ProductGroupPage = (_class = (_temp =
/*#__PURE__*/
function (_react$Component2) {
  _inherits(ProductGroupPage, _react$Component2);

  function ProductGroupPage() {
    var _getPrototypeOf3;

    var _this2;

    _classCallCheck(this, ProductGroupPage);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(ProductGroupPage)).call.apply(_getPrototypeOf3, [this].concat(args)));

    _initializerDefineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "background", _descriptor, _assertThisInitialized(_assertThisInitialized(_this2)));

    _initializerDefineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "id", _descriptor2, _assertThisInitialized(_assertThisInitialized(_this2)));

    _initializerDefineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "spotlight", _descriptor3, _assertThisInitialized(_assertThisInitialized(_this2)));

    _initializerDefineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "subHeadline", _descriptor4, _assertThisInitialized(_assertThisInitialized(_this2)));

    _initializerDefineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "headline", _descriptor5, _assertThisInitialized(_assertThisInitialized(_this2)));

    _initializerDefineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "summary", _descriptor6, _assertThisInitialized(_assertThisInitialized(_this2)));

    _initializerDefineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "catalogGroup", _descriptor7, _assertThisInitialized(_assertThisInitialized(_this2)));

    _initializerDefineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "footerBlocks", _descriptor8, _assertThisInitialized(_assertThisInitialized(_this2)));

    return _this2;
  }

  _createClass(ProductGroupPage, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        id: "page-content-container"
      }, _react.default.createElement("div", {
        className: _classList.default.join('block', 'stack', 'header-block', 'height-50vh', this.background && 'variable-background'),
        "data-landing-page-group": this.id,
        "data-block-type": "header",
        style: this.background ? _base.default.styleForBackgroundObject(this.background) : {}
      }, _react.default.createElement("div", {
        className: "spotlight-header"
      }, this.spotlight && _react.default.createElement(_CatalogGroup.SpotlightCarousel, this.spotlight), _react.default.createElement("div", {
        className: "inner-content animate-fadeIn"
      }, this.subHeadline && _react.default.createElement("h2", null, this.subHeadline), _react.default.createElement("h1", {
        className: "title"
      }, this.headline), this.summary && _react.default.createElement(Fragment, null, _react.default.createElement("hr", null), _react.default.createElement("p", {
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, this.summary))))), _react.default.createElement("div", {
        className: "block stack height-auto"
      }, _react.default.createElement("div", {
        id: "catalogGroupPage"
      }, _react.default.createElement(_CatalogGroupPage.CatalogGroupPage, _extends({
        className: "stack catalog-group product-group"
      }, this.catalogGroup)))), _react.default.createElement(require(this.footerBlocks.child_type).default, this.footerBlocks));
    }
  }], [{
    key: "value",
    value: function value(landingPageGroup, group, page) {
      var rootBlock = _exports.default.Channel.tools.blocks.records.catalogGroupFooter;
      return {
        type: 'pages/ProductGroup',
        name: 'ProductGroupPage',
        footerBlocks: require("block/".concat(rootBlock.child_type)).default.value(rootBlock, page),
        background: landingPageGroup.file_name || group.file_name ? {
          landscape: group.file_name || landingPageGroup.file_name,
          portrait: group.filePortrait_name || landingPageGroup.filePortrait_name || group.file_name || landingPageGroup.file_name,
          imageOverlay: _exports.default.StyleExpressions.evaluate('@imageOverlay')
        } : null,
        spotlight: _CatalogGroup.SpotlightCarousel.value(landingPageGroup, page),
        subHeadline: landingPageGroup.subHeadline,
        headline: landingPageGroup.headline || landingPageGroup.title,
        summary: (landingPageGroup.summary || "").replace(/\s*/, "") ? landingPageGroup.summary : "",
        catalogGroup: {
          groupId: group.id,
          groupInfo: {
            title: group.title,
            image: group.listImage_name || _exports.default.Channel.getDefaultFile('defaultGroupListItemImage')
          },
          groupTree: !!Number(landingPageGroup.hideGroups) ? null : _CatalogGroup.DefaultCatalogGroupPage.getGroupList(group),
          tileList: _CatalogGroup.DefaultCatalogGroupPage.getRecords(landingPageGroup, group, page).map(function (record) {
            return {
              id: record.id,
              type: record.child_type,
              typeLabel: _exports.default.Apps.catalog.config.tool.swt_tool_childData[record.child_type].typeLabel,
              title: record.title.replace(/^\s*/, '').replace(/\s*$/, ''),
              date: record.active_toggle_date || record.created,
              card: require("card/".concat(record.child_type)).default.card(record, page, {
                showRecentCount: page.isFrequent()
              }),
              banner: null,
              views: _exports.default.Channel.tools.userTrack.lwp('find', {
                child_type: 'experienced',
                catalogItem: record.id
              }).records.length
            };
          }),
          sortOrder: _CatalogGroup.DefaultCatalogGroupPage.getSortOrder(group, page),
          filter: _CatalogGroup.DefaultCatalogGroupPage.getFilterType(group, page),
          defaultSortOrder: group.defaultSortOrder,
          includeUserSpecifiedSort: group.defaultSortOrder == 'default' || !Number(group.includeAllItems),
          defaultFilterType: '',
          itemStyle: 'cards',
          base: _exports.default.Link('CatalogGroup', group),
          query: page.searchParameters.q || null,
          className: "stack catalog-group product-group",
          asProductGroup: true,
          asProductGrid: page.isProductGrid(),
          withProductSectionHeader: page.isFrequent(),
          addAllItemsSet: _CatalogGroup.DefaultCatalogGroupPage.getRecords(landingPageGroup, group, page).map(function (item) {
            return item.id;
          }),
          hasPreviousOrders: _exports.default.Channel.tools.orders.lwp('find', {
            client: _cart.default.client.id
          }).records.length > 0,
          cartItems: _cart.default.itemsInCart().map(function (item) {
            var product = item.product,
                quantity = item.quantity,
                basePrice = item.basePrice,
                salePrice = item.salePrice;

            var card = require("card/".concat(product.child_type)).default.card(product, page);

            var brand = product.related[_exports.default.Channel.tools.brands.toolID][0];
            return {
              id: product.id,
              title: product.title.replace(/^\s*/, '').replace(/\s*$/, ''),
              brandName: brand ? brand.brandName : '',
              image: card.image,
              quantity: quantity,
              price: salePrice
            };
          })
        }
      };
    }
  }]);

  return ProductGroupPage;
}(_react.Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "background", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "spotlight", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "subHeadline", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "headline", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "catalogGroup", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "footerBlocks", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.ProductGroupPage = ProductGroupPage;